<template>
  <div>
    <b-card no-body class="p-1 border-0 mb-1" md="12" v-for="groupFilter in this.groupFilters" :key="groupFilter.name" >
      <div slot="header">
        <strong>{{groupFilter.name}}</strong>
      </div>
      <b-row>
        <b-col md="4" v-for="filter in groupFilter.filters"
               :key="filter.id"
               >
               <div v-if="filter.visible">
                  <b-input-group v-if="(filter.id === 'product_category_hlev1_id')">
            <v-select multiple 
                      :options="filter.data"
                      label="name"
                      v-model="filter.selected"
                      :ref="filter.id"
                      :onChange="getProductCategory2">
            </v-select>
          </b-input-group>
          <b-input-group v-else-if="(filter.id === 'product_category_hlev2_id')">
            <v-select multiple :options="filter.data"
                      label="name"
                      v-model="filter.selected"
                      :ref="filter.id"
                      :onChange="getProductCategory3">
            </v-select>
          </b-input-group>
          <b-input-group v-else-if="(filter.type === 'select')">
            <v-select :options="filter.data"
                      label="name"
                      v-model="filter.selected"
                      :ref="filter.id">
            </v-select>
          </b-input-group>
          <b-input-group v-else>
            <v-select multiple :options="filter.data"
                      label="name"
                      v-model="filter.selected"
                      :ref="filter.id">
            </v-select>
          </b-input-group>
               </div>
        </b-col>
      </b-row>
    </b-card>
  </div>
</template>

<script>
  import vSelect from 'vue-select'
  import { parameters } from '@/expertoRetail/constants/payload'
  import { GeneralUtils } from '@/mixins/index'

  export default {
    components: {
      'v-select': vSelect
    },
    mixins: [GeneralUtils],
    data () {
      return {
        showFilters: false,
        groupFilters: [],
        filter: {
          selected: []
        },
        payload: {
          parameters: {
            store_filters: this.$_generalUtils_deepJsonCopy(parameters.store_filters),
            product_filters: this.$_generalUtils_deepJsonCopy(parameters.product_filters)
          }
        }
      }
    },
    created () {
      this.$eventHub.$on('mobile-product-filter', this.getFilters)
    },
    beforeDestroy () {
      this.$eventHub.$off('mobile-product-filter')
    },
    beforeMount () {
      // Se cargan los filtros por defecto en el payload
      if (this.vuexMobileFilters) {
        this.filters = this.vuexMobileFilters
      }
      var headers = this.getHeaders()
      for (var i = 0; i < headers.length; i++) {
        var groupFilter = {}
        groupFilter.name = headers[i]
        groupFilter.filters = this.getFiltersData(headers[i])
        this.groupFilters.push(groupFilter)
      }
    },
    computed: {
      vuexMobileFilters () {
        return this.$store.state.mobile.mobileFilters
      }
    },
    methods: {
      getDependentData (fatherName, parentsId) {
        const productCategoryFilter = this.$store.getters.productCategoryFilters
          .find(productCategoryFilter => productCategoryFilter.levelList
            .find(level => level.id === fatherName)
          )
        if (productCategoryFilter === undefined) {
          return
        }
        const element = JSON.parse(JSON.stringify(productCategoryFilter.levelList.find(level => level.id === fatherName)))
        var data = element.options.filter(x => parentsId.includes(x.parent_id))
        var filtroStore = this.groupFilters.filter(a => a.filters.some(b => b.id === fatherName))[0].filters.filter(c => c.id === fatherName)[0]
        filtroStore.data = data
      },
      getProductCategory2: function (event) {
        this.getDependentData('product_category_hlev2_id', event.map(x => x.id))
      },
      getProductCategory3: function (event) {
        this.getDependentData('product_category_hlev3_id', event.map(x => x.id))
      },
      getHeaders () {
        return this.$store.getters.productCategoryFilters.map(productCategoryFilter => productCategoryFilter.class)
      },
      getFiltersData (head) {
        const vm = this
        let elements = JSON.parse(JSON.stringify(this.$store.getters.productCategoryFilters.find(productCategoryFilter => productCategoryFilter.class === head)))
        elements = elements.levelList.map((levelItem) => {
          // Inicialmente el filtro va a venir vacío en caso que no tenga filtros ya seteados
          let selectedData = []
          /* Veo a que categoría pertenece el filtro, si es a filtro de tienda o de producto
            en ambos casos el proceso es ir a buscar el filtro a  store_filters o product_filters
            según corresponda con su respectivo nombre (retail_id, retail_name, etc..) 
            y finalmente seleccionar todos los match que tenga el filtro con la data que llega por
            cada filtro a través del defaultConfigParameter */
          levelItem.data = levelItem.options
          if (vm.filters.store_filters &&
            Object.keys(vm.filters.store_filters).includes(levelItem.id)) {
            selectedData = levelItem.options.filter(x => vm.filters.store_filters[levelItem.id].includes(x.id))
          } else if (vm.filters.product_filters) {
            selectedData = levelItem.options.filter(x => vm.filters.product_filters[levelItem.id].includes(x.id))
          }
          levelItem.visible = true
          // Finalmente se setea la data por defecto
          levelItem.selected = selectedData
          return levelItem
        })
        if (elements.findIndex(x => x.id === 'store_id') > -1) {
          elements.filter(a => a.id === 'store_id')[0].data = []
        } if (elements.findIndex(x => x.id === 'product_category_hlev2_id') > -1) {
          elements.filter(a => a.id === 'product_category_hlev2_id')[0].data = []
        } if (elements.findIndex(x => x.id === 'product_category_hlev3_id') > -1) {
          elements.filter(a => a.id === 'product_category_hlev3_id')[0].data = []
        }
        return elements
      },
      // Método para armar el payload de los filtros
      getFilters () {
        // Con esto obtengo todos los atributos de los filtros por tienda y por productos
        let storeFiltersKeys = Object.keys(this.payload.parameters.store_filters)
        let productFiltersKeys = Object.keys(this.payload.parameters.product_filters)
        for (var i = 0; i < this.groupFilters.length; i++) {
          for (var j = 0; j < this.groupFilters[i].filters.length; j++) {
            let filter = this.groupFilters[i].filters[j]
            // Si el parameterKey del filtro está dentro de los filtros de tienda, lo agrego al payload correspondiente
            if (storeFiltersKeys.find(x => x === filter.id)) {
              this.payload.parameters.store_filters[filter.id] = filter.selected.map(x => x.id)
              // Sino, si el parameterKey del filtro está dentro de los filtros de producto, lo agrego al payload correspondiente
            } else if (productFiltersKeys.find(x => x === filter.id)) {
              this.payload.parameters.product_filters[filter.id] = filter.selected.map(x => x.id)
            }
          }
        }
        this.$store.commit('commit_newFilters', this.payload.parameters)
        this.$eventHub.$emit('load-data-after-mobile-filter')
      }
    }
  }
</script>



// WEBPACK FOOTER //
// src/expertoRetail/atoms/Mobile/MobileFilter.vue